var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOriginals = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 19 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M16.298 8.333C19.856 5.105 18.648.557 14.21.557h-3.347L9.02 3.889h4.407c1.649 0 1.038 2.778-.607 2.764-.276-.002-1.104.015-1.104.015L9.2 9.996l3.434.005c1.649 0 1.037 2.778-.611 2.778h-5.11l-3.014 3.89h8.917c3.849 0 6.963-6.667 3.481-8.334z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M9.894 0 6.552 6.673h4.069L0 20l3.849-10h-2.75L4.397 0z"
})));
export default SvgOriginals;